import React, { forwardRef, useImperativeHandle } from 'react';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.vfs;

const DrsPdf = forwardRef(({ drsData }, ref) => {
  const generatePDF = () => {
    const deliveryBoy = drsData?.DeliveryBoy?.[0] || {};
    const branch = drsData?.Branch?.[0] || {};
    const pickupDetails = drsData?.PickupDetails || [];

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [20, 20, 20, 30],
      content: [
        // Header Title
        {
          text: 'Liability and Ability LOGISTICS PRIVATE LIMITED',
          alignment: 'center',
          fontSize: 14,
          bold: true,
          margin: [0, 0, 0, 8]
        },

        // Top info rows
        {
          columns: [
            {
              width: '33%',
              stack: [
                { text: `Delivery Boy: ${deliveryBoy.AdminName || 'N/A'}`, fontSize: 9 },
                { text: `Mobile: ${deliveryBoy.Mobile || 'N/A'}`, fontSize: 9 }
              ]
            },
            {
              width: '34%',
              stack: [
                { text: `Branch: ${branch.OfficeName || 'N/A'}`, fontSize: 9 },
                { text: `Area: ${branch.Address || 'N/A'}`, fontSize: 9 },
                { text: `Manual ID: 0`, fontSize: 9 }
              ]
            },
            {
              width: '33%',
              stack: [
                { text: `DRS NO: ${drsData.DRSId || ''}`, fontSize: 9 },
                { text: `DRS Date: ${new Date(drsData.Date).toLocaleDateString()}`, fontSize: 9 },
                { text: `Vehicle No: ${drsData.VehicleNo || ''}`, fontSize: 9 }
              ],
              alignment: 'right'
            }
          ],
          margin: [0, 0, 0, 10]
        },

        // Table
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', '*', '*', '*', '*', '*', '*'],
            body: [
              [
                { text: 'SN', bold: true, fontSize: 9 },
                { text: 'AWB NO', bold: true, fontSize: 9 },
                { text: 'PCS', bold: true, fontSize: 9 },
                { text: 'WEIGHT', bold: true, fontSize: 9 },
                { text: 'CONSIGNOR\nORIGIN', bold: true, fontSize: 9 },
                { text: 'CONSIGNEE\nDESTINATION', bold: true, fontSize: 9 },
                { text: 'COD\nToPay', bold: true, fontSize: 9 },
                { text: 'NAME, SIGNATURE, STAMP,\nMOBILE No., DATE & TIME', bold: true, fontSize: 9 }
              ],
              ...pickupDetails.map((item, idx) => {
                const baseRow = [
                  idx + 1,
                  item?.DocketId || '',
                  item?.NoOfPcs || '',
                  item?.GrossWeight || '',
                  item?.Origin || '',
                  item?.Destination || '',
                  '0.00'
                ];

                if (idx === 0) {
                  return [
                    ...baseRow,
                    {
                      text: '(Signature Section Placeholder)',
                      rowSpan: pickupDetails.length,
                      fontSize: 8,
                      margin: [0, 30, 0, 0],
                      alignment: 'center'
                    }
                  ];
                } else {
                  return [...baseRow, ''];
                }
              })
            ]
          },
          layout: 'lightHorizontalLines',
          fontSize: 8
        },

        // Totals
        {
          columns: [
            { text: `Total AWB No.: ${pickupDetails.length}`, fontSize: 9 },
            { text: `Total Box: ${pickupDetails.length}`, fontSize: 9, alignment: 'right' }
          ],
          margin: [0, 10, 0, 0]
        },

        // Footer
        {
          columns: [
            { text: `User: ${drsData.createdBy || 'N/A'}`, fontSize: 9 },
            { text: 'Check By:', alignment: 'right', fontSize: 9 }
          ],
          margin: [0, 10, 0, 0]
        }
      ]
    };

    pdfMake.createPdf(docDefinition).open();
  };

  useImperativeHandle(ref, () => ({
    generatePDF
  }));

  return <div style={{ display: 'none' }}>DRS PDF</div>;
});

export default DrsPdf;
